
import { Options, Vue } from 'vue-class-component';

import { preferences } from '@/service/preferences';

import MaterialSwitch from '@/components/material/Switch.vue';
import PreferenceRow from './Row.vue';

import locales from './General.locales.json';

@Options({
    components: {
        MaterialSwitch,
        PreferenceRow
    },
    i18n: {
        messages: locales
    }
})
export default class GeneralPreferences extends Vue {

    get queryAfterLatest(): boolean {
        return preferences.general.queryAfterLatest();
    }

    set queryAfterLatest(value: boolean) {
        preferences.general.setQueryAfterLatest(value);
    }
}
